module.exports = "<div role=\"main\" class=\"container\">\r\n\r\n  <h1 class=\"page-header\">Abmeldung</h1>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-md-6 col-md-offset-3\">\r\n\r\n      <p class=\"lead text-center\">Sie werden bei VisBOS abgemeldet und anschließend zur Login-Seite weitergeleitet...!</p>\r\n\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n\r\n<vb-messages></vb-messages>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/visbos-core/components/log-out/log-out.component.html
// module id = ./src/app/core/visbos-core/components/log-out/log-out.component.html
// module chunks = main